import React from 'react'

import { io } from 'socket.io-client'

type data = {
  eligible: number
}
interface IRecommendation {
  topic: string
  userId: string
  customerId: string
  statusCode: string
  eligiblePartnerId: number
  data: data
}

export const useWebSocket = (socketUrl: string, event: string) => {
  const [recommendationData, setRecommendationData] =
    React.useState<IRecommendation>()

  React.useEffect(() => {
    const socket = io(socketUrl)

    socket.on('connect', () => {
      return 'connected'
    })

    socket.on(event, (args: any) => {
      setRecommendationData(args)
      socket.disconnect()
    })
    return () => {
      socket.disconnect()
    }
  }, [socketUrl])

  return recommendationData
}
